<template>
  <highcharts :options="chartOptions"></highcharts>
</template>
  
<script>
import { API } from "@/axios-config";
import { Chart } from "highcharts-vue";

export default {
  name: "ChartViewer",
  props: {
    jobid: {
      type: Number,
      default: 0,
    },
    title: {
      type: String,
      default: "",
    },
    metric: {
      type: String,
      default: "cpu",
    },
    runType: {
      type: String,
      default: "Last run",
    },
    lineWidth: {
      type: Number,
      default: 4,
    },
    url: {
      type: String,
      default: "",
    },
    yAxisLabel: {
      type: String,
      default: "",
    },
    height: {
      type: Number,
      default: 400,
    },
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      chartOptions: {
        credits: {
          enabled: false,
        },
        chart: {
          type: "spline",
          zoomType: "x",
          // Highcharts defaults to a white chart on a dark page - blend
          // into the surrounding (dark) card instead of punching a bright
          // white box into an otherwise dark UI.
          backgroundColor: "transparent",
          height: this.height,
        },
        title: {
          text: this.title,
          style: { color: "rgba(255, 255, 255, 0.87)", fontSize: "1em" },
        },
        // subtitle: {
        //   text:
        //     document.ontouchstart === undefined
        //       ? "Click and drag in the plot area to zoom in"
        //       : "Pinch the chart to zoom in",
        // },
        legend: { enabled: false },
        xAxis: {
          type: "datetime",
          labels: { style: { color: "rgba(255, 255, 255, 0.6)" } },
          lineColor: "rgba(255, 255, 255, 0.2)",
          tickColor: "rgba(255, 255, 255, 0.2)",
        },
        yAxis: {
          title: {
            text: this.yAxisLabel,
            style: { color: "rgba(255, 255, 255, 0.6)" },
          },
          labels: { style: { color: "rgba(255, 255, 255, 0.6)" } },
          gridLineColor: "rgba(255, 255, 255, 0.1)",
          // min: 0,
        },
        plotOptions: {
          spline: {
            lineWidth: this.lineWidth,
            marker: {
              enabled: false,
            },
          },
        },
        series: [],
      },
    };
  },
  methods: {
    async metricsPipeline(value) {
      try {
        const { data } = await API.get(this.url, {
          params: {
            jobid: this.jobid ? parseInt(value) : 0,
            metric: this.metric,
            last: this.runType === "Last run" ? true : false,
          },
        });
        this.chartOptions.series = data;
      } catch (error) {
        console.log(error);
      }
    },
    refreshMetrics(value) {
      this.metricsPipeline(value);
    },
  },
  watch: {
    jobid: {
      handler(value) {
        if (value) {
          this.refreshMetrics(value);
        }
      },
      immediate: true,
      deep: true,
    },
    runType: {
      handler(value) {
        if (value) {
          this.refreshMetrics(this.jobid);
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
  